export enum FilterNameEnum {
  SENSOR_LOCATIONS = "sensor_locations",
  CONTAINER_TRACKING_SENSOR_STATUS = "CONTAINER_TRACKING_SENSOR_STATUS",
}
